// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3C70a","actions":"GroupTable_actions__2zwf3","deleteModalFooter":"GroupTable_deleteModalFooter__2YGHw"};